<div class="container-fluid px-2 px-md-3 px-xl-1 py-3">
  <div class="d-flex flex-column gap-3">
    <section class="entity-config-top rounded-4 overflow-hidden border-0">
      <div class="entity-config-top-hero px-2 px-md-2 py-2">
        <div class="d-flex flex-column gap-3 p-2">
          <div class="d-flex align-items-start justify-content-between gap-3">
            <div>
              <div class="d-flex align-items-center gap-2 mb-1">
                <i class="bi bi-shield-lock-fill text-white fs-5"></i>
                <h1 class="entity-page-title text-white fw-bold lh-sm mb-0">TrustRisk Config</h1>
              </div>
              <p class="entity-page-subtitle text-white mb-0 subsystem-subtitle">
                Configure risk levels, question assignments, and checklist weightings from one place.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="d-flex flex-wrap gap-2">
      <button v-for="tab in tabs" :key="tab.id" type="button"
        class="btn btn-sm rounded-small px-3 py-2 small fw-semibold d-inline-flex align-items-center" :class="active_tab === tab.id
                  ? 'bg-white text-primary border border-primary shadow-sm'
                  : 'bg-white text-secondary border border-secondary border-opacity-25'"
        @click="set_active_tab(tab.id)">
        <i v-if="tab.icon" class="bi me-2" :class="tab.icon"></i>
        {{ tab.label }}
      </button>
    </div>

    <section v-if="active_tab === 'risk_categories'" class="row g-3 align-items-start">
      <div class="col-12 col-xl-8">
        <div class="bg-white rounded-4 border shadow-sm p-4">
          <div class="d-flex align-items-start justify-content-between gap-3 mb-4">
            <div>
              <div class="entity-section-title fw-bold fs-6">Create Risk Levels</div>
              <div class="text-secondary text-xxs">
                Define score ranges such as Low, Medium, and High risk. These ranges will be used when calculating an
                entity's risk score.
              </div>
            </div>

          </div>

          <div v-for="(level, index) in risk_levels" :key="level.id"
            class="border rounded-4 p-3 p-md-4 bg-white shadow mb-4">
            <div class="d-flex align-items-start justify-content-between gap-3 mb-4">
              <div>
                <div class="fw-semibold text-secondary text-xs">Risk Level Details</div>
                <div class="text-secondary text-xxs">Fill in one score band at a time.</div>
              </div>
             <div class="d-flex align-items-center gap-2  py-2 px-2 ms-4">
                <button
                    type="button"
                    class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1"
                    @click="add_risk_level"
                >
                    <i class="fas fa-plus text-white"></i>
                </button>

                <button
                    v-if="risk_levels.length > 1"
                    type="button"
                    class="btn btn-light btn-sm rounded-3 text-danger d-inline-flex align-items-center justify-content-center"
                    @click="remove_risk_level(active_level_index)"
                    aria-label="Delete risk level"
                >
                    <i class="bi bi-trash3-fill"></i>
                </button>
            </div>
            </div>

            <div class="row g-3">
              <div class="col-12">
                <label class="modal-form-label text-xs" :for="`risk_level_name_${level.id}`">Risk Level
                  Name</label>
                <input :id="`risk_level_name_${level.id}`" v-model.trim="level.name" type="text"
                  class="form-control modal-form-control text-xs" placeholder="Example: Low Risk" />
              </div>

              <div class="col-12">
                <label class="modal-form-label text-xs" :for="`auto_decision_${level.id}`">Auto Decision</label>
                <select :id="`auto_decision_${level.id}`" v-model="level.auto_decision"
                  class="form-select modal-form-control text-xs">
                  <option value="">Select decision</option>
                  <option value="approve">approve</option>
                  <option value="review">review</option>
                  <option value="reject">reject</option>
                </select>
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label text-xs" :for="`min_score_${level.id}`">Min Score</label>
                <input :id="`min_score_${level.id}`" v-model.trim="level.min_score" type="number" min="0"
                  class="form-control modal-form-control text-xs" placeholder="Example: 0"
                  :class="active_level_validation.kind === 'range' || active_level_validation.kind === 'overlap' ? 'is-invalid' : ''" />
                <div class="text-secondary text-xxs mt-1">Score ranges should not overlap.</div>
              </div>

              <div class="col-12 col-md-6">
                <label class="modal-form-label text-xs" :for="`max_score_${level.id}`">Max Score</label>
                <input :id="`max_score_${level.id}`" v-model.trim="level.max_score" type="number" min="0"
                  class="form-control modal-form-control text-xs" placeholder="Example: 20"
                  :class="active_level_validation.kind === 'range' || active_level_validation.kind === 'overlap' ? 'is-invalid' : ''" />
                <div class="text-secondary text-xxs mt-1">Score ranges should not overlap.</div>
              </div>

              <div class="col-12">
                <div v-if="active_level_validation.kind === 'incomplete'" class="alert alert-light border text-xs mb-0">
                  Start by entering both a minimum and maximum score for this band.
                </div>
                <div v-else-if="!active_level_validation.valid" class="alert alert-warning border text-xs mb-0">
                  {{ active_level_validation.message }}
                </div>
              </div>

              <div class="col-12">
                <label class="modal-form-label text-xs d-block mb-2" :for="`visual_color_${level.id}`">Visual Colour Indicator</label>
                <div class="d-flex align-items-center gap-2">
                  <input
                    :id="`visual_color_${level.id}`"
                    v-model.trim="level.visual_color"
                    type="color"
                    class="form-control form-control-color rounded-3 border p-1 flex-shrink-0"
                    :class="{ 'is-invalid': !level.visual_color }"
                    :title="level.visual_color || '#2aa5a0'"
                    aria-label="Choose visual colour"
                  />

                  <input
                    v-model.trim="level.visual_color"
                    type="text"
                    class="form-control modal-form-control text-xs"
                    :class="{ 'is-invalid': !level.visual_color }"
                    placeholder="#26A69A"
                  />
                </div>
                <div v-if="!level.visual_color" class="invalid-feedback d-block text-xs">
                  Visual colour is required.
                </div>
              </div>
            </div>
          </div>

          <div class="d-flex flex-column gap-2 mt-3">
            <div class="text-secondary text-xxs">
              Add Another Risk Level adds another score band. Save Risk Levels stores all changes.
            </div>

            <div class="d-flex flex-wrap justify-content-end gap-2">
              <button type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                @click="add_risk_level">
                Add a risk level
              </button>

              <button type="button"
                class="btn entity-assign-btn btn-sm rounded-small fw-semibold px-2 py-1 mt-1"
                :disabled="!can_save_risk_levels" 
                @click="save_risk_categories">
                Save Risk Levels
              </button>
            </div>

          </div>
        </div>
      </div>

      <div class="col-12 col-xl-4">
        <div class="bg-white rounded-4 border shadow-sm p-4 h-100">
          <div class="d-flex align-items-start justify-content-between gap-2 mb-3">
            <div>
              <div class="entity-section-title fw-bold fs-6">Risk Levels Preview</div>
              <div class="text-secondary text-xxs">Review the score bands you have added before saving.</div>
            </div>
            <div class="d-flex flex-column align-items-end gap-1">
              <span class="badge rounded-pill bg-light text-dark border">{{ preview_risk_levels.length }}</span>
            </div>
          </div>

          <div v-if="!preview_risk_levels.length" class="bg-light rounded-4 border p-4 text-center">
            <div
              class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
              <i class="bi bi-shield-check fs-3"></i>
            </div>
            <div class="fw-semibold text-xs mb-1">No risk levels added yet</div>
            <div class="text-secondary text-xxs">
              Start by completing the form on the left.
            </div>
          </div>

          <div v-else class="d-flex flex-column gap-2">
            <button v-for="level in preview_risk_levels" :key="level.id" type="button"
              class="btn text-start border rounded-4 p-3"
              :class="selected_level_index === risk_levels.indexOf(level) ? 'btn-light border-primary shadow-sm' : 'btn-light bg-white border-secondary border-opacity-25'"
              @click="select_risk_level(risk_levels.indexOf(level))">
              <div class="d-flex align-items-start justify-content-between gap-2">
                <div class="min-w-0">
                  <div class="fw-semibold text-xs text-truncate">
                    {{ level.name || `Risk Level ${risk_levels.indexOf(level) + 1}` }}
                  </div>
                  <div class="text-secondary text-xxs text-truncate">
                    {{ level.auto_decision || 'No decision set' }}
                  </div>
                </div>
                <span class="badge rounded-pill"
                  :class="validate_risk_level(level, risk_levels.indexOf(level)).valid ? 'bg-primary-subtle text-primary' : 'bg-warning-subtle text-warning'">
                  {{ validate_risk_level(level, risk_levels.indexOf(level)).valid ? 'Ready' : 'Needs attention' }}
                </span>
              </div>

              <div class="d-flex flex-wrap gap-1 mt-2">
                <span class="badge rounded-pill text-bg-light border text-secondary text-xxs">
                  Min {{ level.min_score || '-' }}
                </span>
                <span class="badge rounded-pill text-bg-light border text-secondary text-xxs">
                  Max {{ level.max_score || '-' }}
                </span>
              </div>

              <div v-if="!validate_risk_level(level, risk_levels.indexOf(level)).valid"
                class="text-danger text-xxs mt-2">
                {{ validate_risk_level(level, risk_levels.indexOf(level)).message }}
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>

    <section v-else-if="active_tab === 'question_assignments'" class="bg-transparent">
      <RiskQuestionnaire :assessment-id="current_assessment_id()" />
    </section>

    <section v-else-if="active_tab === 'checklist_weightings'" class="bg-transparent">
      <ChecklistWeightings :assessment-id="current_assessment_id()" />
    </section>

    <section v-else class="bg-white rounded-4 border shadow-sm p-5 text-center">
      <div
        class="entity-type-icon entity-icon-surface rounded-4 d-inline-flex align-items-center justify-content-center mb-3">
        <i class="bi bi-gear fs-3"></i>
      </div>
      <div class="fw-bold mb-1">Configuration</div>
      <div class="text-secondary small">This section follows the same system styling and will use the same design
        language.</div>
    </section>
  </div>
</div>
